import React, { useEffect, useState } from 'react';
import {
  Card, Form, Row, Col, Button,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import AsyncSelect from 'react-select/async';
import './TeamMembers.less';

import api from '../../../api';
import Required from '../../Required';
import { makeUID } from '../../../helpers';

const ROLE_ADD_LABELS = {
  curator: 'куратора',
  admin: 'администратора',
  participantAdmin: 'участника с правами администратора',
};

export default function TeamMembers({
  title, data, onChange, userRoles, validationFailed, addRole, presetEmployer, disabled
}) {
  const addCard = (role) => {
    const arrToConcat = [{
      id: 0, hash: makeUID(5), userId: undefined, user: {}, post: '', role,
    }];
    if (!data.find((u) => u.role === role)) {
      arrToConcat.push({
        id: 0, hash: makeUID(5), userId: undefined, user: {}, post: '', role,
      });
    }
    onChange(data.concat(arrToConcat));
  };

  const deleteCard = (itemId) => {
    onChange(data.filter((d) => d.hash !== itemId));
  };

  const mapOptionsToValues = (options) =>
    // value, label, isFixed, isDisabled
    options.map((option) => ({
      value: option.id,
      label: `${option.lastName || ''} ${option.firstName || ''} ${option.middleName || ''} (${option.post || 'должность не указана'})`,
      user: option,
    }));

  /** Для выбора у конкретного участника команды доступна только его роль (если уже выбрана) и роли, которые еще не заняты */
  const getAvailableUserRoles = (selectedRole, roles) => {
    const selectedRoles = data ? data.map((d) => d.role) : [];
    return roles.filter((r) => r === selectedRole || selectedRoles.indexOf(r) < 0);
  };

  const getOptions = async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      return callback([]);
    }
    const result = await api.get(`/users/employees?name=${inputValue.trim()}`);
    callback(mapOptionsToValues(result));
  };

  const onUserItemChange = (user, selectedValue, role) => {
    const newItem = {};
    newItem.role = role;
    newItem.userId = selectedValue.value;
    newItem.sAMAccountName = selectedValue.user.sAMAccountName;
    newItem.post = selectedValue.user.post;
    newItem.division = selectedValue.user.division;
    newItem.displayName = `${selectedValue.user.lastName || ''} ${selectedValue.user.firstName || ''} ${selectedValue.user.middleName || ''}`;
    if (user) {
      onChange(data.map((d) => (d.hash === user.hash ? { ...d, ...newItem } : d)));
    } else {
      newItem.hash = makeUID(5);
      onChange([...data, newItem]);
    }
    // let dataCopy = [...data];
    // let changedItem = dataCopy.find(d => d.id === user.id);
    // changedItem.userId = selectedValue.value;
    // changedItem.sAMAccountName = selectedValue.user.sAMAccountName;
    // changedItem.post = selectedValue.user.post;
    // changedItem.displayName = `${selectedValue.user.lastName || ''} ${selectedValue.user.firstName || ''} ${selectedValue.user.middleName || ''}`;
    // onChange(dataCopy);
  };

  const clearSelected = (role) => {
    const filteredArray = data.filter((d) => d.role !== role);
    onChange(filteredArray);
  };

  const getAsyncSelectClassName = (roleKey, item) => (
    !notRequiredRoles.includes(roleKey) && !item && validationFailed
      ? 'reactselect-invalid'
      : 'reactselect-valid'
  );

  const notRequiredRoles = ['curator', 'participantAdmin', 'mainConstructor', 'officeTechLead'];

  return (
    <Card className="mb-4">
      <Card.Header className="p-4">
        <Card.Title style={{ marginBottom: 0 }}>Команда управления</Card.Title>
      </Card.Header>
      <Card.Body className="p-4">
        { Object.entries(userRoles).map(([roleKey, roleName]) => {
          let items = data.filter((d) => d.role === roleKey);
          if (!items.length) items = [null];

          return items.map((item, i) => (
            <Row key={`${roleKey}-${i}`}>
              <Form.Group as={Col}>
                <Card className="mb-4">
                  <Card.Header style={cardHeaderStyling}>
                    {(roleKey === 'mainConstructor' || roleKey === 'officeTechLead') && (
                      <span style={{ color: '#6c757d', fontSize: '14px' }}>
                        Заполняется в случае, если проект входит в СТП
                      </span>
                    )}
                    {(items.length > 1) && (
                      <Button
                        disabled={disabled}
                        onClick={() => deleteCard(item.hash)}
                        variant="light"
                        className="btn-close"
                        size="sm"
                      />
                    )}
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Form.Group as={Col} md="6">
                        <Form.Label>
                          ФИО
                          {!notRequiredRoles.includes(roleKey) && <Required />}
                        </Form.Label>
                        <div>
                          <AsyncSelect
                            isDisabled={roleKey === 'employer' && presetEmployer || disabled}
                            classNamePrefix={getAsyncSelectClassName(roleKey, item)}
                            noOptionsMessage={() => 'Ничего не найдено'}
                            loadingMessage={() => 'Поиск...'}
                            placeholder="Введите ФИО"
                            value={!item ? null : { value: item.userId, label: item.displayName ? (`${item.displayName} (${item.post || 'должность не указана'})`) : '' }}
                            defaultOptions={[]}
                            isClearable
                            loadOptions={getOptions}
                            onChange={(selectedValue, triggeredAction) => {
                              if (triggeredAction.action === 'clear') {
                                return clearSelected(roleKey);
                              }
                              return onUserItemChange(item, selectedValue, roleKey);
                            }}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                          />
                        </div>
                        <Form.Control.Feedback type="invalid">Выберите из списка</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <Form.Label>Роль</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={roleKey}
                          disabled
                        >
                          <option value={roleKey}>{roleName}</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">Выберите из списка</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Card.Body>
                </Card>
              </Form.Group>
            </Row>
          ));
        })}
        {addRole && addRole.map((role) => (
          <Row className="mb-1" key={`${role}-add-btn`}>
            <Form.Group as={Col} md="12">
              <Button onClick={() => addCard(role)} disabled={disabled} variant="outline-primary">
                <PlusLg className="me-1 mb-1" />
                Добавить
                {' '}
                {ROLE_ADD_LABELS[role] || `роль "${userRoles[role]}"` }
              </Button>
            </Form.Group>
          </Row>
        ))}
      </Card.Body>
    </Card>
  );
}

const invalidStyle = {
  borderColor: '#dc3545',
};

const cardHeaderStyling = {
  display: 'flex', minHeight: 38,
};
